<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Ajuste de Inventario</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <router-link
                class="btn btn-sm btn-success"
                :to="{ name: 'inventario-ajuste_inventario-nuevo', params: {}}"
              >
                <i class="fa fa-pencil"></i>
                Nueva Ajuste de Inventario
              </router-link>
              <a class href="#"></a>
              <a
                v-if="mostrarRefresh"
                class="btn btn-sm btn-info"
                @click="refreshData"
                href="#"
              >Refrescar</a>
            </div>
            <div class="col-sm-6">
              <div class="form-inline justify-content-sm-end">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                  v-on:keyup.enter="filterData"
                />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="button" v-on:click="filterData">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filtro_estado"
                  @change="filterData"
                >
                  <option value>Todos</option>
                  <option value="9">Anulado</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <AjusteInventarioTableComponent />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import AjusteInventarioTableComponent from "@/components/inventario/ajuste_inventario/AjusteInventarioTableComponent";

export default {
  components: {
    AjusteInventarioTableComponent,
    UsuarioEnTablaComponent
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: ""
    };
  },
  mounted() {},
  methods: {
    filterData() {
      this.$data.currentPage = 1;
      this.$store.dispatch("ajusteinventario/fetch", {
        page: this.$data.currentPage,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado
      });
    },
    clearFilterData() {
      this.$data.searchtext = "";
      this.$data.currentPage = 1;
      this.$store.dispatch("ajusteinventario/fetch", {
        page: this.$data.currentPage,
        "filter[search]": this.$data.searchtext
      });
    }
  }
};
</script>
